/** First-party cookie: user arrived from Tawan Spa booking hub. */
export const REFERRER_COOKIE = "mediconsult_referrer";
export const TAWAN_REFERRER_VALUE = "tawan-spa";
const MAX_AGE_SEC = 60 * 60 * 24 * 30;

export const captureReferrerFromSearch = (search = "") => {
  if (typeof document === "undefined") return;
  const from = new URLSearchParams(search).get("from");
  if (from === TAWAN_REFERRER_VALUE || from === "tawan-spa-booking") {
    document.cookie = `${REFERRER_COOKIE}=${TAWAN_REFERRER_VALUE}; path=/; max-age=${MAX_AGE_SEC}; SameSite=Lax`;
  }
};

export const hasTawanReferrer = () => {
  if (typeof document === "undefined") return false;
  return document.cookie
    .split(";")
    .some((part) => part.trim() === `${REFERRER_COOKIE}=${TAWAN_REFERRER_VALUE}`);
};
